import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { Records } from '@components/Records/Records'

export const Members = () => {
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
          {
            title: 'Members',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
        ],
      },
    })
  }

  return <Records handleNavigate={handleNavigate} />
}
